<template>
    <div id="payment-options">
        <button id="add-tip" @click="$router.push('tip')" class="button-primary">
            <table>
                <tr>
                    <td class="action-label">Tip</td>
                    <td class="action-value">{{ tip | toCurrency }}</td>
                    <td class="action-icon"><img class="button-caret" src="~@/assets/images/caret-right-white.png" /></td>
                </tr>
            </table>
        </button>

        <!-- We order the buttons from most stable to least stable. Credit card will always be available. Google
             Pay is available even on mac/iOS devices, so we will keep the button visible and instead, show an alert
             message if readyToPay is false. Apple Pay is very situational. We'll show/hide the button dynamically. 
             since it's last on the list. It won't cause the page elements to shift. -->
        <template v-if="isBraintree">
            <button @click="$router.push('creditcard/0')" class="button-secondary payment-type-button">Credit Card</button>
            <BraintreeGooglePay />
            <BraintreeApplePay />
        </template>
        <template v-if="isPayeezy">
            <button @click="$router.push('creditcard/1')" class="button-secondary payment-type-button">Credit Card</button>
            <PayeezyGooglePay />
            <PayeezyApplePay />
        </template>
        <template v-if="isShift4">
            <button @click="$router.push('creditcard/2')" class="button-secondary payment-type-button">Credit Card</button>
            <Shift4ApplePayGooglePay />
        </template>
    </div>
</template>

<script>
    import BraintreeGooglePay from "./PaymentMethods/Braintree/BraintreeGooglePay";
    import BraintreeApplePay from "./PaymentMethods/Braintree/BraintreeApplePay";
    import PayeezyGooglePay from "./PaymentMethods/Payeezy/PayeezyGooglePay.vue";
    import PayeezyApplePay from "./PaymentMethods/Payeezy/PayeezyApplePay.vue";
    import Shift4ApplePayGooglePay from "./PaymentMethods/Shift4/Shift4ApplePayGooglePay.vue";
    import { paymentProcessors } from "../constants/payment-processors";

    export default {
        name: 'PaymentOptions',
        components: {
            BraintreeGooglePay,
            BraintreeApplePay,
            PayeezyGooglePay,
            PayeezyApplePay,
            Shift4ApplePayGooglePay
        },
        computed: {
            tip() {
                return this.$store.state.session.tip;
            },
            isBraintree() {
                return this.$store.state.session.paymentProcessor === paymentProcessors.braintree;
            },
            isPayeezy() {
                return this.$store.state.session.paymentProcessor === paymentProcessors.payeezy;
            },
            isShift4() {
                return this.$store.state.session.paymentProcessor === paymentProcessors.shift4;
            }
        }
    }
</script>

<style scoped>
    #payment-options {
        background-color: var(--white);
        padding: 15px 20px 15px 20px;
    }

    #add-tip {
        margin-bottom: 30px;
    }

    button {
        width: 100%;
    }

    .button-primary table {
        width: 100%;
    }

    .action-label {
        width: 100%;
        text-align: left;
    }

    .action-value {
        width: 60px;
        text-align: right;
        font-size: 15px;
    }

    .action-icon {
        width: 14px;
    }

    .action-icon {
        width: 14px;
        vertical-align: middle;
    }

    .payment-type-button {
        margin-bottom: 12px;
    }
</style>